import { configureStore } from "@reduxjs/toolkit";
import { businessApi } from "./api/businessApi";

export const store = configureStore({
  reducer: {
    [businessApi.reducerPath]: businessApi.reducer,
    // add other reducers here if needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(businessApi.middleware),
});
